import { USBColumn } from "@usb-shield/react-grid/dist/esm";
import { CommonLayoutProps } from "lib";
import PropTypes from "prop-types";
import React from "react";

const CenteredLayout = ({ children, compact, ...otherProps }: CommonLayoutProps) => (
  <USBColumn
    layoutOpts={{
      spans: {
        xlarge: compact ? 10 : 8,
        large: compact ? 10 : 8,
        medium: compact ? 8 : 6,
        small: 4
      },
      offset: {
        xlarge: compact ? 3 : 4,
        large: compact ? 3 : 4,
        medium: compact ? 0 : 1
      }
    }}
    {...otherProps}
  >
    {children}
  </USBColumn>
);
export default CenteredLayout;

CenteredLayout.propTypes = {
  children: PropTypes.node.isRequired,
  otherProps: PropTypes.any,
  compact: PropTypes.bool
};
CenteredLayout.defaultProps = {
  otherProps: {}
};
